module.exports = __webpack_public_path__ + "7c4b269e152ff1240cec354fd9afbbc8.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/704.png
// module id = 1687
// module chunks = 2